import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    // General
    formula: null,
    audienceInEditionId: null,

    // Breakdown
    formulaBreakdown: null,
    formulaBreakdownLoading: false,

    // Resume
    formulaSummary: null,
    formulaSummaryLoading: false,

    // Volumes
    formulaGlobalVolume: null,
    formulaVolumes: null,
    formulaVolumesLoading: false,
    formulaVolumeType: 'ID based',
    resetFormula: false
}

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
}
